module.exports = __webpack_public_path__ + "static/media/file_warning_icon.e547730f.svg";